import React, { FC } from 'react';

export const TableOfContentsList: FC = ({ children }) => {
  return <ul className='space-y-1'>{children}</ul>;
};
